@if (!isLoading && isUserSelect) {
  <ziro-reassign-user-search
    [reassignType]="ReassignTypes.PUBLIC_TO_USER"
    [serverId]="serverId"
  ></ziro-reassign-user-search>
}
@if (!isLoading && !isUserSelect) {
  <ziro-reassign-user-execute
    [reassignType]="ReassignTypes.PUBLIC_TO_USER"
    [isVoicemailPresentOnLineOne]="isVoicemailPresentOnLineOne"
    [publicPhoneVoicemailRef]="publicPhoneVoicemailRef"
    [serverId]="serverId"
    [siteId]="siteId"
    (reassignClicked)="onReassignClicked($event)"
  ></ziro-reassign-user-execute>
}
